import pick from 'lodash/pick';
import values from 'lodash/values';
import {
  AddressDTO,
} from 'dtos';
import {
  isEmptyString,
  notEmptyString,
} from '@populateui/utils';

type AddressFields = Pick<AddressDTO, 'street' | 'unit' | 'city' | 'state' | 'zipCode'>;

export const addressFields = Object.freeze(['street', 'unit', 'state', 'zipCode', 'city']);
export const requiredAddressFields = Object.freeze(new Set(['street', 'state', 'zipCode', 'city']));

export const addressRequiredFieldsNotEmpty = (
  address: AddressFields,
) => values(pick(address, Array.from(requiredAddressFields))).every(notEmptyString);

export const validateAddress = (
  address: AddressFields,
) => (
  values(pick(address, addressFields)).every(isEmptyString)
    || values(pick(address, Array.from(requiredAddressFields))).every(notEmptyString)
);

export const validateZipCode = (value: unknown) => (
  isEmptyString(typeof value === 'string' ? value : String(value ?? ''))
    ? true
    : /^\d{5}(-\d{4})?$/.test(typeof value === 'string' ? value : String(value ?? ''))
);
export const validateLongZipCode = (value: unknown) => (
  isEmptyString(typeof value === 'string' ? value : String(value ?? ''))
    ? true
    : /^\d{5}-\d{4}$/.test(typeof value === 'string' ? value : String(value ?? ''))
);

export const validateAddressInfo = (
  value?: AddressFields,
) => validateAddress((value ?? {}) as Pick<AddressDTO, 'street' | 'unit' | 'city' | 'state' | 'zipCode'>) && validateZipCode((value as AddressDTO | undefined)?.zipCode);

export const validateAddressWithLongZipCode = (
  address?: AddressFields,
) => (addressRequiredFieldsNotEmpty(address as AddressFields)
  && validateLongZipCode((address as AddressFields | undefined)?.zipCode)
);
